import { render, staticRenderFns } from "./novo-acesso.vue?vue&type=template&id=5039e480&"
import script from "./novo-acesso.vue?vue&type=script&lang=ts&"
export * from "./novo-acesso.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports